import {getCachedTableStateSlice} from 'src/hooks/common-data-service/cached-table';

import type {CachedTableStateSelector} from 'src/hooks/common-data-service/cached-table/typedef';
import type {PresetsFilter} from 'src/modules/manage-entitlements/all-entitlements/presets/typedef';

export const presetsStateSlice = getCachedTableStateSlice<
    undefined,
    undefined,
    PresetsFilter
>('presetsState', undefined, {pageSize: 5, currentPage: 1});

export const presetsStateActions = presetsStateSlice.actions;
export const presetsStateSelector: CachedTableStateSelector<undefined, undefined, PresetsFilter> =
    state => state.manageEntitlements.presetsReducer.presetsState;
